import type {
  RouteLocationNormalized,
  RouteLocationRaw,
  RouteRecordRaw,
} from 'vue-router';
import { PaymentStatusOptions } from 'src/components/constants';
import { CompanyPermissionsCodename, PermissionsCodename } from 'src/api';
import { requireUserPermission } from 'src/router/guards/requireUserPermission';
import { requireCompanyPermission } from 'src/router/guards/requireCompanyPermission';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const paymentRoutes: RouteRecordRaw[] = [
  // redirect from back after payment
  {
    path: '/payments',
    name: 'payments-redirect',
    props: true,
    component: () => import('layouts/AppLayout.vue'),
    redirect: (to: RouteLocationNormalized): RouteLocationRaw => {
      const paymentStatus = to.query.payment_status;
      if (paymentStatus === PaymentStatusOptions.PAID) {
        return { name: 'successfull-payment' };
      } else if (paymentStatus === PaymentStatusOptions.REJECTED) {
        return { name: 'failed-payment' };
      } else {
        return { name: 'home' }; // or redirect to a default/fallback route
      }
    },
    children: [],
  },
];

export const paymentResultRoutes: RouteRecordRaw[] = [
  {
    path: 'thank-you',
    alias: $gettext('dekujeme'),
    name: 'successfull-payment',
    component: () => import('src/pages/ThankYouPage.vue'),
  },
  {
    path: 'error',
    alias: $gettext('chyba'),
    name: 'failed-payment',
    component: () => import('src/pages/RejectedPage.vue'),
  },
];

// Platby → web `/payments` (`/platby`). The mobile payment page keys off
// `visitId` only, whereas web `create-payment` needs `patientId`+`visitId`, so
// this uses a DISTINCT name (`visit-payment`) rather than reusing the web name
// — prevents shared-code `router.push({ name })` from resolving to a mismatched
// screen. Documented parity gap.
export const mobilePaymentRoutes: RouteRecordRaw[] = [
  {
    path: 'payments',
    alias: $gettext('platby'),
    children: [
      {
        path: ':visitId/pay',
        alias: ':visitId/' + $gettext('zaplatit'),
        name: 'visit-payment',
        props: true,
        beforeEnter: [
          requireUserPermission(PermissionsCodename.CREATE_SELF_RECEIPT),
          requireCompanyPermission(CompanyPermissionsCodename.ALLOW_PAYMENTS),
        ],
        component: () => import('pages/mobile/MobilePaymentsPage.vue'),
      },
    ],
  },
];
